export default {
      id: "rate-of-return-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#rate-of-return",
      toString: function () {
        return this.url;
      }
    }